/** HTTP-`detail` aus FastAPI in lesbaren Text umwandeln. */
export function formatValidationDetail(detail: unknown): string {
  if (typeof detail === "string") return detail;
  if (!detail || typeof detail !== "object") return "Unbekannter Serverfehler.";
  const obj = detail as Record<string, unknown>;
  if (typeof obj.message === "string") {
    const issues = obj.issues;
    if (Array.isArray(issues) && issues.length > 0) {
      const list = issues.filter((i): i is string => typeof i === "string").slice(0, 5);
      if (list.length > 0) {
        return `${obj.message} ${list.join("; ")}`;
      }
    }
    return obj.message;
  }
  try {
    return JSON.stringify(detail);
  } catch {
    return "Unbekannter Serverfehler.";
  }
}
